import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'Free Online Games to Play Without Downloading | Gamezop',
  desc: 'Play free online games without downloading them on Gamezop. 200+ free games to play, including action, adventure, arcade, puzzle, racing, and more. Play now!',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'ಫ್ರೀ ಆನ್ಲೈನ್ ಗೇಮ್ಸ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡದೆ ಆಡಲು',
    body: {
      text: [
        `Gamezop ನಲ್ಲಿ ಡೌನ್‌ಲೋಡ್ ಇಲ್ಲದೆ ಉಚಿತ ಆನ್‌ಲೈನ್ ಗೇಮ್‌ಗಳನ್ನು ಆಡಿ!
        ನಿಮಗೆ ಇಷ್ಟವಾದ ಆಟವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ ಮತ್ತು ಕೆಲವು ಸೆಕೆಂಡುಗಳಲ್ಲಿ ಆಟವನ್ನು ಪ್ರಾರಂಭಿಸಿ. ನಮ್ಮಲ್ಲಿ 200+ ಉಚಿತ ಗೇಮ್‌ಗಳು ಲಭ್ಯವಿದ್ದು, ಅವು ಆಕ್ಷನ್, ಅಡ್ವೆಂಚರ್, ಆರ್ಕೇಡ್, ಪಜಲ್, ರೇಸಿಂಗ್ ಮತ್ತು ಇತರ ಜಾತಿಗಳನ್ನು ಒಳಗೊಂಡಿವೆ. ನೀವು ಮೊಬೈಲ್, PC ಅಥವಾ iOS ನಲ್ಲಿ ಆಡಲು ಬಯಸಿದರೆ, Gamezop ನಿಮಗಾಗಿ ಅತ್ಯುತ್ತಮ ಆಟಗಳನ್ನು ಒದಗಿಸುತ್ತದೆ.`,
        `ನಿಮಗೆ ಬೋರ್ ಆಗಿದೆಯಾ? Gamezop ನಲ್ಲಿ ಅನೇಕ ಮನರಂಜನೆಯ ಆಯ್ಕೆಗಳು ಇವೆ. Kingdom Fight, City Cricket, Fruity Fiesta ಹೀಗೇ ಅನೇಕ ರೋಮಾಂಚಕ ಆಟಗಳನ್ನು ಆಡಿ! ನಮ್ಮ ಆಟಗಳು ಮಕ್ಕಳು, ವಯಸ್ಕರು ಮತ್ತು ಹಿರಿಯರು ಎಲ್ಲರಿಗೂ ಸೂಕ್ತವಾಗಿವೆ.`,
        `ಈ ಆಟಗಳನ್ನು ಆಡಲು ನಿಮಗೆ ದುಬಾರಿ ಸಾಧನಗಳ ಅಗತ್ಯವಿಲ್ಲ. ಬ್ರೌಸರ್ ಮತ್ತು ಇಂಟರ್‌ನೆಟ್ ಸಂಪರ್ಕ ಇದ್ದರೆ ಸಾಕು. ನೀವು ಡೆಸ್ಕ್‌ಟಾಪ್, ಲ್ಯಾಪ್‌ಟಾಪ್, ಕ್ರೋಂಬುಕ್, ಸ್ಮಾರ್ಟ್‌ಫೋನ್, ಟ್ಯಾಬ್ಲೆಟ್ ಮೇಲೆ ಸುಲಭವಾಗಿ ಆಟ ಆಡಿ.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: 'ಏನು ಬೆಸ್ಟ್ ಫ್ರೀ ಆನ್‌ಲೈನ್ ಗೇಮ್ಸ್?',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'ಸ್ನೇಹಿತರೊಂದಿಗೆ ಆಡುವ ಫ್ರೀ ಆನ್‌ಲೈನ್ ಗೇಮ್ಸ್ ಏನು?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'ಮೋಸ್ಟ್ ಪಾಪುಲರ್ ಆನ್‌ಲೈನ್ ಗೇಮ್ಸ್ ಶೈಲಿ ಯಾವುದು?',
    body: {
      text: [],
      list: [
        {
          name: 'ಕ್ರೇಜಿ ಗೇಮ್ಸ್',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'ಬೋರ್ಡ್ ಗೇಮ್ಸ್',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'ಅಡ್ವೆಂಚರ್ ಗೇಮ್ಸ್',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'ಪಜಲ್ ಗೇಮ್ಸ್',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'ಶೂಟಿಂಗ್ ಗೇಮ್ಸ್',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Gamezop ಎಂದರೇನು',
    body: {
      text: [
        `Gamezop ಒಂದು ಪ್ಲಗ್-ಅಂಡ್-ಪ್ಲೇ ಗೇಮಿಂಗ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್, ಇದು ಯಾವುದೇ ಅಪ್ಲಿಕೇಶನ್ ಅಥವಾ ವೆಬ್‌ಸೈಟ್‌ಗಳಲ್ಲಿ ಸುಲಭವಾಗಿ ಗೇಮ್ಸ್‌ ಅನ್ನು ಇಂಟಿಗ್ರೇಟ್ ಮಾಡಲು ಮತ್ತು ಬಳಕೆದಾರರ ಎಂಗೇಜ್‌ಮೆಂಟ್ ಅನ್ನು ಹೆಚ್ಚಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ. ಗೇಮಿಂಗ್‌ನ ಹೊರತಾಗಿ, Gamezop ಹಲವಾರು ವಿಶೇಷ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳನ್ನು ನಿರ್ವಹಿಸುತ್ತದೆ: Quizzop ಇಂಟರಾಕ್ಟಿವ್ ಕ್ವಿಜ್‌ಗಳು ಮತ್ತು ಟ್ರಿವಿಯಾದಿಗಾಗಿ, Astrozop ಜ್ಯೋತಿಷ್ಯದ ಮಾಹಿತಿಗಳು ಮತ್ತು ಭವಿಷ್ಯವಾಣಿಗಾಗಿ, Criczop ಲೈವ್ ಕ್ರಿಕೆಟ್ ಸ್ಕೋರ್‌ಗಳು ಮತ್ತು ನವೀಕರಣಗಳಿಗಾಗಿ ಮತ್ತು Feedzop ಆಯ್ದ ಸುದ್ದಿಗಳನ್ನು ಒದಗಿಸಲು. ಇವುಗಳು ಸೇರಿ ವಿವಿಧ ಪ್ರೇಕ್ಷಕರ ಆಸಕ್ತಿಗಳಿಗೆ ತಕ್ಕಂತ ವೈವಿಧ್ಯಮಯ ಕಂಟೆಂಟ್ ಸೊಲ್ಯೂಷನ್‌ಗಳನ್ನು ಒದಗಿಸುತ್ತವೆ.`,
        `8,000 ಕ್ಕೂ ಹೆಚ್ಚು ಇಂಟಿಗ್ರೇಷನ್‌ಗಳು, 70 ಕ್ಕೂ ಹೆಚ್ಚು ದೇಶಗಳಲ್ಲಿ, Gamezop ಮತ್ತು ಅದರ ಸಹ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳು Amazon, Samsung Internet, Snap, Tata Play, AccuWeather ಮತ್ತು Paytm ಇಂತಹ ವಿಶ್ವಾಸಾರ್ಹ ಬ್ರ್ಯಾಂಡ್‌ಗಳ ನಂಬಿಕೆಯನ್ನು ಗಳಿಸಿಕೊಂಡಿವೆ. ಈ ಸೊಲ್ಯೂಷನ್‌ಗಳು ಬಳಕೆದಾರರ ಎಂಗೇಜ್‌ಮೆಂಟ್ ಹೆಚ್ಚಿಸುವುದಲ್ಲದೇ, ಹೊಸ ಜಾಹೀರಾತು ಆದಾಯದ ಅವಕಾಶಗಳನ್ನು ತೆರೆದಿಡುತ್ತವೆ. ಇಂಟಿಗ್ರೇಷನ್‌ ಪ್ರಕ್ರಿಯೆ ಕೇವಲ 30 ನಿಮಿಷಗಳಲ್ಲಿ ಪೂರ್ಣಗೊಳ್ಳುತ್ತದೆ, ಮತ್ತು ಅಪ್ಲಿಕೇಶನ್‌ಗಳು ಮತ್ತು ವೆಬ್‌ಸೈಟ್‌ಗಳು ಗೇಮ್ಸ್, ಕ್ವಿಜ್‌ಗಳು, ಜ್ಯೋತಿಷ್ಯ, ಕ್ರಿಕೆಟ್ ಮತ್ತು ಸುದ್ದಿಗಳ ಮೂಲಕ ಮನೋರಂಜನಾ ಕಂಟೆಂಟ್ ಒದಗಿಸಬಹುದಾಗಿದೆ.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'ಎಫ್‌ಎಕ್ಯೂಸ್',
  faqs: [
    {
      tag: 'h3',
      title: 'ಫ್ರೀ ಗೇಮ್ಸ್ ಅನ್ನು ಡೌನ್‌ಲೋಡಿಂಗ್ ಅಥವಾ ಇನ್‌ಸ್ಟಾಲಿಂಗ್ ಇಲ್ಲದೇ ಆಡಲು ಸಾಧ್ಯವಿದೆಯೇ?',
      body: ['ಹೌದು, ನೀವು ಫ್ರೀ ಗೇಮ್ಸ್ ಅನ್ನು ಇನ್‌ಸ್ಟಾಲಿಂಗ್ ಅಥವಾ ಡೌನ್‌ಲೋಡಿಂಗ್ ಇಲ್ಲದೇ ಆಡುವುದಕ್ಕೆ ಸಾಧ್ಯ.'],
    },
    {
      tag: 'h3',
      title: 'ಆಡುವುದಕ್ಕಾಗಿ ಸೈನ್ ಅಪ್ ಅಗತ್ಯವಿದೆಯೇ?',
      body: [
        'ಇಲ್ಲ, Gamezop.com ನಲ್ಲಿ ಗೇಮ್ಸ್ ಆಡುವುದಕ್ಕೆ ಸೈನ್ ಅಪ್ ಮಾಡುವ ಅಗತ್ಯವಿಲ್ಲ. ನೀವು ಯಾವುದೇ ನೋಂದಣೆಯ ಅಗತ್ಯವಿಲ್ಲದೇ ತಕ್ಷಣ ಆಟ ಪ್ರಾರಂಭಿಸಬಹುದು.',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/kn',
      },
    },
    {
      tag: 'h3',
      title: 'ಆನ್‌ಲೈನ್ ಗೇಮ್ಸ್ ಆಡುವುದು ಸುರಕ್ಷಿತವೇ?',
      body: [
        'ಹೌದು, ಟ್ರಸ್ಟೆಡ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ಸ್ ಮೇಲೆ ಆನ್‌ಲೈನ್ ಗೇಮ್ಸ್ ಆಡುವುದು ಸುರಕ್ಷಿತವಾಗಿದೆ. ಉದಾಹರಣೆಗೆ Gamezop, ನಮ್ಮ ಗೇಮ್ಸ್ ಡೌನ್‌ಲೋಡ್ಸ್ ಅಗತ್ಯವಿಲ್ಲ, ಇದರಿಂದ ಮಾಲ್ವೇರ್ ಅಪಾಯಗಳು ಕಡಿಮೆಯಾಗುತ್ತವೆ. ನಾವು ಯೂಸರ್ ಸೆಕ್ಯೂರಿಟಿ ಮೇಲೆ ಗಮನಹರಿಸುತ್ತೇವೆ ಮತ್ತು ನಿಮ್ಮ ಪ್ರೈವೆಸಿ ಅಥವಾ ಡಿವೈಸ್ ಸುರಕ್ಷತೆಗೆ ಯಾವುದೇ ಹಾನಿ ಆಗದಂತೆ ನೋಡಿಕೊಳ್ಳುತ್ತೇವೆ.',
      ],
    },
    {
      tag: 'h3',
      title: 'ಫ್ರೀ ಗೇಮ್ಸ್ ನಿಜವಾಗಿಯೂ ಉಚಿತವೇ?',
      body: [
        'ಹೌದು, Gamezop ನಲ್ಲಿ ಫ್ರೀ ಗೇಮ್ಸ್ ನಿಜವಾಗಿಯೂ ಉಚಿತವಾಗಿ ಆಡಬಹುದು. ಆದರೆ, ಈ ಗೇಮ್ಸ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ ಅನ್ನು ಬೆಂಬಲಿಸಲು ಜಾಹೀರಾತುಗಳನ್ನು ಪ್ರದರ್ಶಿಸಬಹುದು.',
      ],
    },
    {
      tag: 'h3',
      title: 'ಮೇಚ್ಛಿವಯಸ್ಸಿನವರಿಗೆ (ಸೀನಿಯರ್ಸ್) ಆನ್‌ಲೈನ್ ಫ್ರೀ ಗೇಮ್ಸ್ ಇದೆಯೇ?',
      body: [
        'ಹೌದು, ನಾವು ಸೀನಿಯರ್ಸ್ ಗಾಗಿ ಫ್ರೀ ಗೇಮ್ಸ್ ಹೊಂದಿದ್ದೇವೆ, ಇವುಗಳಲ್ಲಿ Sudoku Classic, Solitaire Gold, Chess Grandmaster ಮತ್ತು ಇನ್ನೂ ಹಲವಾರು ಆಟಗಳನ್ನು ಆನ್‌ಲೈನ್ ಆಡುವಂತೆ ಮಾಡಲಾಗಿದೆ.',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
